<template>
	<a-drawer
		:title="title"
		placement="right"
		:width="width"
		:zIndex="zIndex"
		wrapClassName="user-detail-drawer-wrap"
		:visible="visible"
		:destroyOnClose="true"
		:body-style="{ padding: '16px 24px', overflowY: 'auto', height: 'calc(100vh - 55px)' }"
		@close="close"
	>
		<user-detail
			v-if="visible && userId"
			:id="userId"
			:embedded="true"
			@loaded="onLoaded"
		/>
	</a-drawer>
</template>

<script>
	import UserDetail from '@/pages/member/user/UserDetail.vue';

	export default {
		name: 'UserDetailDrawer',
		components: {
			UserDetail,
		},
		props: {
			width: {
				type: [Number, String],
				default: 1360,
			},
			zIndex: {
				type: Number,
				default: 1000,
			},
		},
		data() {
			return {
				visible: false,
				userId: null,
				title: '用户详情',
			};
		},
		methods: {
			open(id) {
				const userId = Number(id);
				if (!userId) {
					return;
				}
				this.userId = userId;
				this.title = `用户详情 (${userId})`;
				this.visible = true;
			},
			close() {
				this.visible = false;
				this.userId = null;
				this.title = '用户详情';
			},
			onLoaded({ nickname, id }) {
				this.title = `${nickname || '用户详情'} (${id})`;
			},
		},
	};
</script>
